export interface ComponentProp {
  name: string;
  type: 'string' | 'number' | 'boolean' | 'array' | 'object';
  label: string;
  description?: string;
  required?: boolean;
  defaultValue?: unknown;
  options?: Array<{ value: string; label: string }>; // For select/enum types
  validation?: {
    min?: number;
    max?: number;
    minLength?: number;
    maxLength?: number;
    pattern?: string;
  };
}

export interface ComponentStyling {
  margin?: string;
  padding?: string;
  backgroundColor?: string;
  textColor?: string;
  borderRadius?: string;
  border?: string;
  customCSS?: string;
}

export interface ComponentDefinition {
  id: string;
  name: string;
  displayName: string;
  description?: string;
  category: 'Content' | 'Layout' | 'Data' | 'Interactive' | 'Other';
  version: string;
  isActive: boolean;
  isSystem?: boolean;
  icon?: string;
  preview?: string; // HTML preview of the component
  props: ComponentProp[];
  defaultStyling?: ComponentStyling;
  htmlTemplate: string; // HTML template with prop placeholders
  cssTemplate?: string; // CSS template
  jsTemplate?: string; // JavaScript template for interactive components
  dependencies?: string[]; // External dependencies needed
  tags?: string[];
  createdAt: string;
  updatedAt: string;
  createdBy: string;
}

export interface CreateComponentRequest {
  name: string;
  displayName: string;
  description?: string;
  category: ComponentDefinition['category'];
  icon?: string;
  preview?: string;
  props: ComponentProp[];
  defaultStyling?: ComponentStyling;
  htmlTemplate: string;
  cssTemplate?: string;
  jsTemplate?: string;
  dependencies?: string[];
  tags?: string[];
}

export interface UpdateComponentRequest extends Partial<CreateComponentRequest> {
  id: string;
}

export interface ComponentListResponse {
  components: ComponentDefinition[];
  total: number;
  page: number;
  limit: number;
}

export interface ComponentInstanceProps {
  [key: string]: unknown;
}

export interface ComponentInstance {
  id: string;
  componentId: string;
  props: ComponentInstanceProps;
  styling?: ComponentStyling;
}

export const COMPONENT_CATEGORIES = [
  'Content',
  'Layout', 
  'Data',
  'Interactive',
  'Other'
] as const;

export const COMPONENT_PROP_TYPES = [
  'string',
  'number',
  'boolean',
  'array',
  'object'
] as const;